import React, { PureComponent } from 'react';
import { Modal } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';
import './loader.css';

class Loader extends PureComponent {
  render() {
    const { show, loadingText } = this.props;

    window.top.postMessage(
      { scrollToTop: true },
      process.env.REACT_APP_PARENT_DOMAIN
    );

    return (
      <Modal show={show} className="dap_loader">
        <Modal.Body className="dap_loader-center">
          <PulseLoader size={20} color="#d64b36" />
          <p> {loadingText} </p>
        </Modal.Body>
      </Modal>
    );
  }
}

export default Loader;
